import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { api } from "@/lib/api";

export default function HeroSlider() {
    const [slides, setSlides] = useState([]);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const res = await api.get("/hero-sliders");
                setSlides(res?.data || []);
            } catch (err) {
                console.error(err);
            }
        };

        fetchSlides();
    }, []);

    const sortedSlides = [...slides].sort(
        (a, b) => a.order - b.order
    );

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
            <div className="overflow-hidden rounded-2xl shadow-soft">

                <Swiper
                    modules={[Autoplay, Pagination]}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                    speed={800}
                >
                    {sortedSlides.map((item) => (
                        <SwiperSlide key={item.id}>

                            <div className="w-full aspect-[16/7] md:aspect-[16/8] lg:aspect-[16/6] bg-gray-100">
                                <img
                                    src={item.image}
                                    alt="slider"
                                    className="w-full h-full object-fill lg:object-cover"
                                />
                            </div>

                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </div>
    );
}